var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgLink = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.362007 40.9011L9.09711 49.638C9.58143 50.1207 10.3615 50.1207 10.8458 49.638L36.0824 24.4L42.6793 39.6087C42.9008 40.1177 43.4346 40.4184 43.9848 40.3401C44.535 40.2635 44.9674 39.8294 45.0383 39.2759L49.9894 1.3958C50.0396 1.01608 49.9095 0.63306 49.6385 0.362065C49.3667 0.0902452 48.9845 -0.0390751 48.604 0.0103466L10.7239 4.96158C10.4463 4.99782 10.1975 5.12467 10.0097 5.3133C9.82441 5.49863 9.69839 5.74162 9.65968 6.01591C9.58225 6.56531 9.8829 7.09989 10.3919 7.32064L25.6003 13.916L0.362007 39.154C-0.120667 39.6375 -0.120667 40.4184 0.362007 40.9011Z",
    fill: "url(#paint0_linear_2038_3582)",
    fillOpacity: 0.7
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2038_3582",
    x1: 8.04381,
    y1: 50.1939,
    x2: 41.5066,
    y2: 9.00987,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#04052E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F359C"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLink, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/link.b69ab297.svg";
export { ForwardRef as ReactComponent };